import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const attributes = {
    addition: undefined,
    axis: undefined,
    baseCurve: undefined,
    color: undefined,
    cylinder: undefined,
    diameter: undefined,
    power: undefined
};
const initialState = {
    left: attributes,
    right: attributes
};
const reducer = (state, action)=>{
    switch(action.type){
        case 'set':
            {
                const { key , value  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    [key]: swcHelpers.objectSpread({}, state[key], value)
                });
            }
        case 'clear':
            {
                const key = action.payload;
                if (key) {
                    return swcHelpers.objectSpread({}, state, {
                        [key]: initialState[key]
                    });
                }
                return initialState;
            }
        default:
            return state;
    }
};
const useAttributes = ()=>{
    const [attributes1, dispatch] = React.useReducer(reducer, initialState);
    const setAttribute = React.useCallback((eyeSide, attribute, value)=>dispatch({
            type: 'set',
            payload: {
                key: eyeSide,
                value: {
                    [attribute]: value
                }
            }
        })
    , []);
    const reset = React.useCallback(()=>dispatch({
            type: 'clear'
        })
    , []);
    const clearEyeSide = React.useCallback((eyeSide)=>dispatch({
            type: 'clear',
            payload: eyeSide
        })
    , []);
    const actions = React.useMemo(()=>({
            clearEyeSide,
            reset,
            setAttribute
        })
    , []);
    return React.useMemo(()=>[
            attributes1,
            actions
        ]
    , [
        actions,
        attributes1
    ]);
};

export { initialState, reducer, useAttributes };
//# sourceMappingURL=use-attributes.js.map
